import { useQuery } from "react-query";
import { getDistributionListsForOrder } from "@/api/ApplicationOrders/get-oa-distribution-lists-api";

export const useGetDistributionListsForOrder = (orderApplicationId) => {
	return useQuery(["distribution-lists-for-order", orderApplicationId], () => getDistributionListsForOrder(orderApplicationId), {
		enabled: !!orderApplicationId,
		staleTime: 1000 * 60 * 5,
		select: (response) => response.data || [],
	});
};
